(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-settings"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cookie-settings]');
    if (!button) return;
    const error = button.parentElement.querySelector('[data-cookie-settings-error]');
    error.hidden = true;
    try {
      if (!window.privacyBanner?.showPreferences) throw new Error('Unavailable');
      await window.privacyBanner.showPreferences();
    } catch {
      error.hidden = false;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
